/* eslint-disable no-useless-computed-key */
import DownloadIcon from '@mui/icons-material/Download';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from '../../../components/layout/Card';
import { Flex, Grid, MarginHandler } from '../../../styledComponents';
import ButtonCom from '../../../components/button/ButtonCom';
import TransitionsModal from '../../../components/modal/Modal';
import InputControl from '../../../components/input/InputControl';
import { Box, Button, CircularProgress, IconButton, LinearProgress, Switch, TextField, Tooltip } from '@mui/material';
import { colors } from '../../../utils';
import FilledSelectOption from '../../../components/input/FilledSelectOption';
import { endPoints } from '../../../api/apiEndpoints';
import { Api } from '../../../api/api';
import Table from '../../../components/table/Table';
import { setAllGovNews } from '../../../redux/slices/posts/posts';
import { useLocation } from 'react-router-dom';
import { successNotify } from '../../../utils/helper';
import EditIcon from '@mui/icons-material/Edit';
import DeleteModal from '../../../components/deletemodal/DeleteModal';
import DeleteIcon from '@mui/icons-material/Delete';
import { setAboutUs } from '../../../redux/slices/aboutus/aboutus';
import { setUserDetails } from '../../../redux/slices/auth/activeAccount';
import ReadMoreReact from "read-more-react"
import moment from 'moment';
import Editor from 'react-simple-wysiwyg';
import NoAccountsIcon from '@mui/icons-material/NoAccounts';

const Profile = () => {

	const dispatch = useDispatch();
	const location = useLocation();

	const { clientId, userId, fullName, userDetails } = useSelector((state) => state?.activeAccount);
	const { aboutus } = useSelector((state) => state?.aboutus);

	const { colorWhite, colorPrimary, colorGreenGradient } = colors;

	const [isLoading, setIsLoading] = useState(false);
	const [isLoadingImg, setIsLoadingImg] = useState(false);
	const [isLoadingModal, setIsLoadingModal] = useState(false);
	const [error, setError] = useState(false);
	const [confirmPasswordVal, setConfirmPasswordVal] = useState("");

	const [formData, setFormData] = useState({
		firstname: '',
		lastname: '',
		email: '',
		number: '',
		image: '',
	});
	const [copyFormData, setCopyFormData] = useState({
		firstname: '',
		lastname: '',
		email: '',
		number: '',
		image: '',
	});

	// const getProfile = async () => {
	// 	setIsLoading(true)
	// 	try {

	// 		await Api.get(`${endPoints?.aboutUs?.fetch}/all`, {
	// 			headers: {
	// 				'xt-user-token': null
	// 			}
	// 		})
	// 			.then((response) => {
	// 				dispatch(
	// 					setAboutUs(
	// 						response?.data?.data?.about?.map((d, index) => ({
	// 							index: index + 1,
	// 							id: d?.id,
	// 							firstname: d?.firstname,
	// 							description: d?.description,
	// 							img: d?.img,
	// 							dt: d?.dt,
	// 							creator_id: d?.creator_id,
	// 							creator_name: d?.creator_name,
	// 							is_enabled: d?.is_enabled,
	// 						})
	// 						),
	// 					),
	// 				);
	// 				setIsLoading(false)
	// 			})
	// 			.catch((error) => {
	// 			});
	// 	} catch (err) {
	// 	}
	// };



	const handleChange = (e) => {
		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};
	const handleConfirmPassword = (e) => {
		if (e.target.value !== formData.password) {
			setError(true);
		} else {
			setError(false);
		};
		setConfirmPasswordVal(e.target.value)
	}


	const handleImageUpload = (event) => {
		setIsLoadingImg(true)
		if (event.target.files.length > 0) {
			let formData = new FormData();
			let file = event.target.files[0];
			let fileName = file.name.replace(/\s/g, '');
			let timestampedFileName = `${new Date().getTime()}_${fileName}`;

			formData.append('file', file, timestampedFileName);
			Api.post(endPoints?.file?.upload, formData, {
				headers: {
					'Content-Type': 'multipart/form-data',
					'xt-user-token': null
				}
			})
				.then((response) => {
					setIsLoadingImg(false)
					setFormData((prevState) => ({
						...prevState,
						image: response.data.data.link,
					}));
					successNotify("Image Uploaded Successfully")

				})
				.catch((error) => {
					// if (error?.response?.status === 400) {
					// 	errorNotify(error?.response?.data);
					// 	setDisabledBtn(false);
					// }
					// setErrMsg(error?.response?.data?.message || errorMsg);
				});

			// setErrMsg('Login Failed');

		}
	};


	const handleSubmit = async () => {
		const changes = Object.keys(formData).reduce((acc, key) => {
			if (formData[key] !== copyFormData[key]) {
				acc[key] = formData[key];
			}
			return acc;
		}, {});

		// Send only the changed values to the API
		if (Object.keys(changes).length > 0) {
			try {
				const data = {
					...changes,
					clientId: userDetails.client_id,
					enabled: userDetails.enabled,
				};

				await Api.put(`${endPoints?.profile?.update}/${userDetails.uuid}`, data, {
					headers: {
						'xt-user-token': null
					}
				})
					.then((response) => {
						successNotify("Profile Updated Successfully!")
						// Update userDetails in Redux (redux-persist will sync to localStorage)
						const updatedUserDetails = {
							...userDetails,
							firstName: formData.firstname,
							lastName: formData.lastname,
							email: formData.email,
							number: formData.number,
							image: formData.image,
						};
						dispatch(setUserDetails(updatedUserDetails));
						setCopyFormData({ ...formData });
					})
					.catch((error) => {

					});
			} catch (err) {
			}
		}

	};

	useEffect(() => {
		if (userDetails) {
			setFormData((prevState) => ({
				firstname: userDetails.firstName,
				lastname: userDetails.lastName,
				email: userDetails.email,
				number: userDetails.number,
				image: userDetails.image,
			}));
			setCopyFormData((prevState) => ({
				firstname: userDetails.firstName,
				lastname: userDetails.lastName,
				email: userDetails.email,
				number: userDetails.number,
				image: userDetails.image,
			}));
		}
	}, [userDetails])
	return (
		<>
			<Card margin='3rem 1.5rem' padding='3rem'>


				{/* <MarginHandler width='100%'> */}

				{isLoadingImg ?
					<CircularProgress sx={{ margin: "auto" }} color="success" />
					:
					<>
						<div style={{ display: "flex", justifyContent: "space-between", flexDirection: "column", alignItems: "center" }}>

							{formData?.image &&
								<img height={100} style={{ margin: "auto", borderRadius: "50%", border: "1px solid lightgrey" }} src={formData?.image} />
							}
							<input
								accept=".jpeg, .jpg, .png"
								style={{ display: 'none' }}
								id="image-upload"
								type="file"
								onChange={(event) => handleImageUpload(event)}
							/>
							<label htmlFor="image-upload">
								<Button
									variant="contained"
									component="span"
									fullWidth
									color='success'
									style={{ fontSize: '1em', marginTop: "10px" }}
								>
									Change Profile
								</Button>
							</label>
						</div>
					</>}

				<Grid gtc='repeat(auto-fit, minmax(50rem, 1fr))' margin='2.5rem 0' padding='2rem'>

					<InputControl
						state={formData?.firstname}
						onChange={handleChange}
						label='firstname'
						name='firstname'
					/>
					<InputControl
						state={formData?.lastname}
						onChange={handleChange}
						label='lastname'
						name='lastname'
					/>
					<InputControl
						state={formData?.email}
						onChange={handleChange}
						label='email'
						name='email'
					/>
					<InputControl
						state={formData?.number}
						onChange={handleChange}
						label='number'
						name='number'
					/>
					<InputControl
						state={formData?.password}
						onChange={handleChange}
						label='Password'
						name='password'
					/>
					{/* <InputControl
						state={formData?.confirmPassword}
						onChange={handleConfirmPassword}
						label='Confirm Password'
						name='confirmPassword'
					/>
					{error && <p style={{ color: "red" }}>password do not match</p>} */}


				</Grid>







				<Flex jc='flex-end' fw='wrap'>

					<ButtonCom btnTitle='Save' onClickHandler={handleSubmit} />


				</Flex>


			</Card>
		</>
	);
};

export default Profile;
